<template>
  <FancyDialog :isPadding="false" v-bind="{ ...$attrs }" v-on="$listeners">
    <v-container fluid class="dialog_container">
      <!-- <img
                width="90"
                height="90"
                class="mb-1"
                src="@/assets/images/imgWarning.svg"
                alt=""
            /> -->
      <div
        style="
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 28px;
          align-items: start;
          padding: 0 16px;
          text-align: start;
        "
      >
        <p class="large-title2-semibold" style="color: #ff9f4b">
          <!-- 確定扣除 {{ card }} {{ point }}點，領取{{ sub }}? -->
          {{ card?.title}}
        </p>
        <p class="body-regular" style="color: #0d0c0c">
          <!-- 不得兌換現金及其他商品或找零。 -->
          {{ card?.description }}
        </p>
      </div>
      <!-- <p class="title mb-3">確定扣除{{ point }}點，領取{{ sub }}，不得兌換現金及其他商品或找零。</p> -->
      <div style="display: flex; gap: 16px">
        <Button text="取消" class="cancel_btn" @click="toggleConfirmPopup" />
        <Button
          text="確定"
          bolder
          class="sure_btn"
          @click="
            toggleConfirmPopup()
            exchangeRewardCoupon(card_id, tNo)
          "
        />
      </div>
      <!-- <div class="footer d-flex justify-center">
        <FancyButton isRed class="btn mr-3" label="取消" @click="toggleConfirmPopup" />
        <FancyButton
          isGreen
          class="btn"
          label="確定"
          @click="
            toggleConfirmPopup()
            exchangeRewardCoupon(card_id, tNo)
          "
        />
      </div> -->
    </v-container>
  </FancyDialog>
</template>

<script>
import FancyDialog from '@/components/FancyDialog.vue'
import Button from '@/components/Atom/Button.vue'
// import FancyButton from '@/components/FancyButton.vue'
export default {
  components: {
    FancyDialog,
    Button,
    // FancyButton,
  },
  name: 'PopupCardExchange',
  props: {
    point: {
      type: Number,
    },
    sub: {
      type: String,
    },
    toggleConfirmPopup: {
      type: Function,
    },
    exchangeRewardCoupon: {
      type: Function,
    },
    card_id: {
      type: String,
    },
    tNo: {
      type: String,
    },
    card: {
      type: Object,
    }
  },
  emits: ['input', 'click:confirm'],
  data: () => ({}),
}
</script>

<style lang="scss" scoped>
.sure_btn {
  background-color: #ff9f4b;
  color: #fff;
  border-radius: 18px;
  padding: 16px;
  width: 50%;
  &:active {
    background-color: #d16200;
  }
}
.cancel_btn {
  background-color: white;
  color: #ff9f4b;
  border: solid 2px #ff9f4b;
  border-radius: 18px;
  padding: 16px;
  width: 50%;
  &:active {
    background-color: #ff9f4b;
    color: white;
  }
}
div.dialog_container {
  position: relative;
  z-index: 1;
  padding: 32px 16px 24px 16px;
  p.title {
    color: $color_main_first;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    letter-spacing: -0.3px;
  }
  p.desc {
    font-size: 14px;
    line-height: 24px;
    color: $color_main_black;
  }
  > .footer {
    .btn {
      height: 50px;
      width: 100%;
      @media screen and (max-width: 374px) {
        max-width: 118px;
      }
      @media screen and (min-width: 375px) {
        max-width: 145.5px;
      }
    }
  }
}
</style>
